if (!customElements.get('site-loader')) {
    class SiteLoader extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        if (document.readyState === 'complete') {
          this.hide();
        } else {
          window.addEventListener('load', () => this.hide());
        }
      }
  
      hide() {
        const wrapper = this.querySelector('#loader-wrapper');
        if (wrapper) {
          wrapper.classList.add('loader-hidden');
          setTimeout(() => {
            wrapper.style.display = 'none';
          }, 500);
        }
      }
    }
    customElements.define('site-loader', SiteLoader);
  }